import { useCallback, useMemo, type ReactNode } from 'react';
import Toggle from '@creditflowresearch/uilib/Toggle';
import type { IColumn } from '@creditflowresearch/uilib/Table/DataTable';

import columnsStyles from '../columnsTabContent.module.scss';

interface IUseHideDeselectedColumnProps {
  getHideDeselected: () => boolean,
  onToggleHideDeselected: () => void,
}

const useHideDeselectedColumn = (
  { getHideDeselected, onToggleHideDeselected }: IUseHideDeselectedColumnProps,
): IColumn => {
  const HideDeselectedHeadCell = useCallback((): ReactNode => (
    <th className={ columnsStyles.hideDeselectedHeader }>
      <span className={ columnsStyles.hideDeselectedToggle }>
        <Toggle
          id="hideDeselected"
          name="hideDeselected"
          dataTest="hideDeselectedToggle"
          checked={ getHideDeselected() }
          onChange={ onToggleHideDeselected }
        />
        <span className={ columnsStyles.hideDeselectedLabel }>Hide deselected columns</span>
      </span>
    </th>
  ), [getHideDeselected, onToggleHideDeselected]);

  return useMemo((): IColumn => ({
    name: 'hideDeselected',
    title: '',
    isDraggable: false,
    width: 260,
    minWidth: 260,
    maxWidth: 260,
    CustomHeadCell: HideDeselectedHeadCell,
  }), [HideDeselectedHeadCell]);
};

export default useHideDeselectedColumn;
